import React from "react";
import mobileImage from "../Image/Mobile-screen-image.png";
import { useTranslation } from "react-i18next";
import AppStore from '../Image/Play-Store.png'
import PlayStore from '../Image/App-Store.png'
import { m, LazyMotion, domAnimation } from "framer-motion";

const DownloadApp = () => {
  const { t } = useTranslation();

  return (
    <LazyMotion features={domAnimation}>
      <section className="application pt-5 p-lg-0" style={{ overflow: "hidden" }}>
        <div className="container">
          <div className="row">
            <m.div
              className="col-sm-12 col-md-6 p-0 px-lg-0 px-md-0 px-3 download-app-desk align-self-center text-lg-start text-md-start text-center"
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true, amount: 0.1 }}
              transition={{ duration: 0.4, ease: "easeOut" }}
              style={{ willChange: "opacity" }}
            >
              <p className="DownloadappTxt1 pb-0" style={{ color: "var(--primary-color)" }}>{t("download_app.title")}</p>
              <h2
                className="DownloadappTxt2"
                dangerouslySetInnerHTML={{
                  __html: t("download_app.heading"),
                }}
                style={{ color: "var(--text-dark)" }}
              />
              <p className="DownloadappTxt3 mb-4 mt-3" style={{ color: "var(--text-light)" }}>
                {t("download_app.subheading")}
              </p>
              <div className="mb-lg-0 mb-3 d-flex align-items-center justify-content-center justify-content-lg-start justify-content-md-start gap-1">
                <m.a
                  href="https://play.google.com/store/apps/details?id=com.nitya.mala.app"
                  whileHover={{ scale: 1.03, transition: { duration: 0.2, ease: "easeOut" } }}
                  whileTap={{ scale: 0.95 }}
                  target="_blank"
                  rel="noreferrer"
                  className="d-inline-block"
                >
                  <img
                    src={AppStore}
                    width="150px"
                    alt="app_store"
                    loading="lazy"
                  />
                </m.a>
                <m.a
                  href="https://play.google.com/store/apps/details?id=com.nitya.mala.app"
                  whileHover={{ scale: 1.03, transition: { duration: 0.2, ease: "easeOut" } }}
                  whileTap={{ scale: 0.95 }}
                  target="_blank"
                  rel="noreferrer"
                  className="d-inline-block"
                >
                  <img
                    src={PlayStore}
                    width="150px"
                    alt="play_store"
                    loading="lazy"
                  />
                </m.a>
              </div>
            </m.div>
            <m.div
              className="col-sm-12 col-md-6 align-self-end text-center"
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true, amount: 0.1 }}
              transition={{ duration: 0.5, ease: "easeOut" }}
              style={{ willChange: "opacity" }}
            >
              <img
                src={mobileImage}
                alt="mobileImage"
                className="mobileImage"
                loading="lazy"
                decoding="async"
              />
            </m.div>
          </div>
        </div>
      </section>
    </LazyMotion>
  );
};

export default DownloadApp;
